import { option, taskEither } from "fp-ts";
import { RuntimeLocaleKey, useFormatMessage } from "../../../../intl";
import { Dialog } from "@dbn/omnichannel-design-system-g4p";
import { CurrentLiabilitiesDialogContent } from "./CurrentLiabilitiesDialogContent";
import { Dispatch, SetStateAction } from "react";
import { useCommand } from "../../../../useAPI";
import { constVoid, pipe } from "fp-ts/function";
import * as standardLoanApi from "./api";

type Props = {
  setIsLiabilitiesDialogOpen: Dispatch<SetStateAction<boolean>>;
};

export function CurrentLiabilitiesDialog(props: Props) {
  const formatMessage = useFormatMessage();
  const cancelWithoutSavingStandardLoan = useCommand(
    standardLoanApi.cancelWithoutSaving
  );
  const handleClose = () => props.setIsLiabilitiesDialogOpen(false);

  return (
    <Dialog
      ariaLabelMessageForCloseIcon={formatMessage(
        "Modal.closeButton" as RuntimeLocaleKey
      )}
      title={formatMessage("StandardLoan.ExpensesConfirmation.Dialog.title")}
      size="small"
      actions={[]}
      onDismiss={option.some(
        pipe(
          cancelWithoutSavingStandardLoan(),
          taskEither.bimap(constVoid, handleClose)
        )
      )}
      variant="left"
      mobileModalHeight={"90dvh"}
    >
      <CurrentLiabilitiesDialogContent onClose={handleClose} />
    </Dialog>
  );
}
